import styled from 'styled-components'
import Modal from 'react-modal'

export const StyledModal = styled(Modal)`
  position: absolute;
  inset: 40px;
  border: 1px solid rgb(204, 204, 204);
  background: rgb(255, 255, 255);
  overflow: auto;
  border-radius: 10px;
  outline: none;
  padding: 20px;
  max-width: 470px;
  margin: auto;
  max-height: 82vh;
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
  @media(max-width: 580px) {
    max-height: 63vh;
    max-width: 320px;
  }
`